import { IconPaths, ModalSize } from '../../../../../../../_metronic/helpers'
import { useT } from '_metronic/i18n/Metronici18n'
import { Button, useModal } from '../../../../../../components'
import { EmpresaEditModalForm } from '../modal/EmpresaEditModalForm'

const EmpresasListToolbar = () => {
  const { showModal } = useModal()
  const { t } = useT()

  const openAddEmpresa = () =>
    showModal({
      title: `${t('empresa.label')}`,
      content: <EmpresaEditModalForm />,
      size: ModalSize.ExtraLarge,
    })

  return (
    <Button onClick={openAddEmpresa} icon={IconPaths.Add} className='btn-primary'>
      {t('common.add')}
    </Button>
  )
}

export { EmpresasListToolbar }
